import { createContext, useContext, useState, useEffect } from 'react';
import { getUserData } from './api';
import pwaNotificationService from '../services/pwaNotifications';

const UserContext = createContext();

export const useUserContext = () => {
  return useContext(UserContext);
};

// Sales Base (or Sales Advanced, which includes it): sees prices and can use QuickBooks.
// The server enforces it too; this only hides what the person can't use.
export const useHasSalesBase = () => {
  const { user } = useUserContext();
  return Boolean(user && user.has_sales_base);
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    if (storedToken) {
      setAuthToken(storedToken);
    }
  }, []);

  useEffect(() => {
    if (authToken) {
      const fetchUserData = async () => {
        try {
          const response = await getUserData();
          setUser(response.data);
        } catch (error) {
          console.error('Failed to fetch user data:', error);
        }
      };

      fetchUserData();
    }
  }, [authToken]);

  // Once someone is signed in, keep their phone's push registration working (only if
  // they already turned notifications on; see refreshRegistration).
  const userId = user ? user.id : null;
  useEffect(() => {
    if (userId) pwaNotificationService.refreshRegistration();
  }, [userId]);

  const value = {
    user,
    setUser,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
